const ClasicMass=[
    {
        id:1,
        title:"Bloody Mary 350мл",
        price:"200 грн",
        src: require('../img/BloodyMary.png'),
        text:`Горілка, 
Томатний сік,
Сік лимону, 
Сіль,
Перець,
Вустерський соус`,
//  isHalloween: true
    },
    {
        id:2,
        title:"Беліні 150мл",
        price:"190 грн",
        src: require('../img/beli.webp'),
        text:"prosecco, пюре персикове",
    },
    {
        id:3,
        title:"Май Тай 450мл",
        price:"250 грн",
        src: require('../img/may.webp'),
        text:"ром чорний, ром золотий, лікер мигдальний, лікер апельсиновий, сік апельсиновий, ананасовий",
    },
    {
        id:4,
        title:"Лонг Айленд 450мл",
        price:"250 грн",
        src: require('../img/long.webp'),
        text:"ром, джин, горілка, текіла, лікер апельсиновий, лимонний фреш, пепсі",
    },{
        id:5,
        title:"порнстар мартіні  200мл",
        price:"240 грн",
        src: require('../img/pornstart.png'),
        text:`ванільна горілка, ванільний сироп, маракуйя, лайм, просекко`,
    },
    {
        id:6,
        title:"Мохіто 350мл",
        price:"190 грн",
        src: require('../img/moh.webp'),
        text:"ром, лайм, м’ята, цукор, 7up",
    },
    {
        id:7,
        title:"Капітан-кола 250мл",
        price:"200 грн",
        src: require('../img/cuba.webp'),
        text:"ром, лайм, пепсі",
    },
    {
        id:8,
        title:"Апероль спрітц 350мл",
        price:"265 грн",
        src: require('../img/aper.webp'),
        text:"апероль, просекко, тонік",
    },
    {
        id:9,
        title:"Джин-тонік 250мл",
        price:"200 грн",
        src: require('../img/ton.webp'),
        text:"джин, тонік, лимон",
    },
    {
        id:10,
        title:"Пінья колада 350мл",
        price:"220 грн",
        src: require('../img/colada.webp'),
        text:"ром, лікер кокосовий, сік ананасовий, вершки, пюре ананас",
    },
    // {
    //     id:10,
    //     title:"Гарібальді 250мл",
    //     price:"160 грн",
    //     src: require('../img/gari.webp'),
    //     text:"кампарі, сік апельсиновий",
    // },
    {
        id:11,
        title:"Блакитні Гаваї 350мл",
        price:"220 грн",
        src: require('../img/gav.webp'),
        text:"ром, кокосовий лікер, лікер Блю Кюрасао, ананасовий сік",
    },
    {
        id:12,
        title:"Бетон 250мл",
        price:"165 грн",
        src: require('../img/beton.png'),
        text:"Бехерівка, Тонік",
    },
    {
        id:13,
        title:"Негроні 200мл",
        price:"230 грн",
        src: require('../img/neg.webp'),
        text:"джин, червоний вермут, кампарі, цедра апельсина",
    },
    // {
    //     id:14,
    //     title:"Бульвардье 200мл",
    //     price:"220 грн",
    //     src: require('../img/bul.webp'),
    //     text:"Бурбон Буліт, червоний вермут, кампарі, цедра апельсина",
    // },
    {
        id:15,
        title:"Віскі сауер 200мл",
        price:"250 грн",
        src: require('../img/sau.webp'),
        text:"Бурбон Буліт, лимонний фреш, ізі фом, цукровий сироп, лимонна цедра, ангостура",
    },
    // {
    //     id:16,
    //     title:"Хрещений батько 120мл",
    //     price:"170 грн",
    //     src: require('../img/kre.webp'),
    //     text:"віскі белс, мигдальний лікер, коктейльна вишня",
    // },
    {
        id:17,
        title:"Срібна затока 400мл",
        price:"250 грн",
        src: require('../img/zaliv.webp'),
        text:"джин, кокосовий лікер, персиковий лікер, сік ананасовий, сік апельсиновий",
    },
    {
        id:18,
        title:"Секс на пляжі 350мл",
        price:"210 грн",
        src: require('../img/bich.webp'),
        text:"горілка, персиковий лікер, сік апельсиновий, журавлиний морс",
    },
    {
        id:19,
        title:"Сік Джунглів 350мл",
        price:"220 грн",
        src: require('../img/jus.webp'),
        text:"джин, лікер «Зелений банан» сік апельсиновий",
    },
    {
        id:20,
        title:"Текіла санрайз 350мл",
        price:"210 грн",
        src: require('../img/sun.webp'),
        text:"текіла, сироп Гренадін, сік апельсиновий",
    },
    {
        id:21,
        title:"Маргарита 200мл",
        price:"220 грн",
        src: require('../img/margo.png'),
        text:`Текіла, куантро, сік лайма, сіль`,
    },
    // {
    //     id:22,
    //     title:"Космополітен 120мл",
    //     price:"160 грн",
    //     src: require('../img/kosmo.webp'),
    //     text:"горілка, апельсиновий лікер журавлиний морс, лаймовий фреш, мараскинова вишня",
    // },
    {
        id:23,
        title:"Блакитна лагуна 350мл",
        price:"200 грн",
        src: require('../img/lagu.webp'),
        text:"горілка, лікер Блю Кюрасао, лимонний фреш, 7up",
    },
    // {
    //     id:24,
    //     title:"Дайкірі 120мл",
    //     price:"150 грн",
    //     src: require('../img/day.webp'),
    //     text:"ром, цукровий сироп, лаймовий фреш",
    // },
    {
        id:25,
        title:"Манхеттен 120мл",
        price:"220 грн",
        src: require('../img/manh.webp'),
        text:"бурбон, червоний вермут, ангостура",
    },
    // {
    //     id:26,
    //     title:"Кловер клаб 120мл",
    //     price:"180 грн",
    //     src: require('../img/club.webp'),
    //     text:"джин гордонс, малиновий сироп, лаймовий фреш, яєчний білок, м’ята",
    // },
    // {
    //     id:27,
    //     title:"Чорний бармен 200мл",
    //     price:"160 грн",
    //     src: require('../img/bar.webp'),
    //     text:"горілка, лікер кавовий, сироп ванільний",
    // },
    {
        id:28,
        title:"Білий бармен 200мл",
        price:"180 грн",
        src: require('../img/belbar.webp'),
        text:"горілка, лікер кавовий, сироп ванільний, вершки",
    },
    {
        id:29,
        title:"викрутка 250мл",
        price:"120 грн",
        src: require('../img/vikr.png'),
        text:"горілка, сік апельсиновий",
    },
    {
        id:30,
        title:"бренді кола 250мл",
        price:"150 грн",
        src: require('../img/brendycoe.png'),
        text:"бренді коблево, пепсі",
    },
    {
        id:31,
        title:"Red Bull Vodka 300мл",
        price:"180 грн",
        src: require('../img/romwiskeyvodkabull.png'),
        text:"Red Bull, горілка",
    },
    {
        id:32,
        title:"Flying Deer 300мл",
        price:"220 грн",
        src: require('../img/jagercherry.png'),
        text:"Jägermeister, Red Bull",
    },
    {
        id:33,
        title:"віскі кола 250мл",
        price:"170 грн",
        src: require('../img/cuba.webp'),
        text:"віскі, пепсі",
    },
    {
        id:34,
        title:"Корона санрайз",
        price:"230 грн",
        src: require('../img/corona2.png'),
        text:"корона, текіла, сироп гренадін, апельсиновий сік, лайм",
    },
    {
        id:35,
        title:"Білий глінтвейн  300мл",
        price:"169 грн",
        src: require('../img/biliyglint.png'),
        isHot: true,
        text:`Дон Сімон біле напів солодке,
Сироп яблоко, 
Апельсин,
Лимон,
Кориця,
Спеції`,
    },
    {
        id:36,
        title:"глінтвейн  300мл",
        price:"169 грн",
        src: require('../img/biliyglint.png'),
        isHot: true,
        text:`Дон Сімон червоне напів солодке,
золотий ром,
Апельсин, 
Лимон, 
Кориця,
цукровий сироп, 
Спеції`,
    },
]

export default ClasicMass;


 
 



